export function getdata() {
	let obj = {
		
			headData: [{
					title: "税（费）种",
					prop:'title',
					width: "300px",
					custom: true,
					fixed:'left'
				},
				{
					title: "计税（费）依据",
					children:[{
					title: "增值税税额",
						children:[{
							title: "1",
							prop: "zzsxgm_2_x_1",
							custom: true,
							width: "200px",
						}]
					},{
					
					title: "增值税限额减免金额",
						children:[{
							
							title: "2",
							prop: "zzsxgm_2_x_2",
							custom: true,
							width: "200px",
						}]
					}]
				},
				{
					
					title: "税（费）率（%）",
					children:[{
						
						title: "3",
						prop: "zzsxgm_2_x_3",
						custom: true,
						width: "200px",
					}]
				},
				{
					
					title:'本期应纳税（费）额',
					children:[{
						
						title: "4=(1+2)x3",
						prop: "zzsxgm_2_x_4",
						custom: true,
						width: "200px",
					}]
				},
				{
					title:'本期减免税（费）额',
					children:[{
					
					title: "减免性质代码",
						children:[{
							
							title: "5",
							prop: "zzsxgm_2_x_5",
							custom: true,
							width: "200px",
						}]
					},{
					
					title: "减免税（费）额",
						children:[{
							
							title: "6",
							prop: "zzsxgm_2_x_6",
							custom: true,
							width: "200px",
						}]
					}]
				},
				{
					title:'增值税小规模纳税人“六税两费”减征政策',
					children:[{
					
					title: "减征比例（%）",
						children:[{
							
							title: "7",
							prop: "zzsxgm_2_x_7",
							custom: true,
							width: "200px",
						}]
					},{
						
						title: "减征额",
						children:[{
							
							title: "8=（4-6）×7",
							prop: "zzsxgm_2_x_8",
							custom: true,
							width: "200px",
						}]
					}]
				},{
					
					title:'本期已缴税（费）额',
					children:[{
						
						title: "9",
						prop: "zzsxgm_2_x_9",
						custom: true,
						width: "200px",
					}]
				},{
					
					title:'本期应补（退）税（费）额',
					children:[{
						
						title: "10=4-6-8-9",
						prop: "zzsxgm_2_x_10",
						custom: true,
						width: "200px",
					}]
				},
			],
			tableData: [{
					title: "城市维护建设税",
					disabledzzsxgm_2_x_1:true,
					disabledzzsxgm_2_x_2:false,
					disabledzzsxgm_2_x_3:false,
					disabledzzsxgm_2_x_4:true,
					disabledzzsxgm_2_x_5:false,
					disabledzzsxgm_2_x_6:false,
					disabledzzsxgm_2_x_7:false,
					disabledzzsxgm_2_x_8:true,
					disabledzzsxgm_2_x_9:false,
					disabledzzsxgm_2_x_10:true,
					zzsxgm_2_x_1: {
						cellCode:"zzsxgm_2_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_2: {
						cellCode:"zzsxgm_2_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_3: {
						cellCode:"zzsxgm_2_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_4: {
						cellCode:"zzsxgm_2_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_5: {
						cellCode:"zzsxgm_2_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_6: {
						cellCode:"zzsxgm_2_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_7: {
						cellCode:"zzsxgm_2_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_8: {
						cellCode:"zzsxgm_2_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_9: {
						cellCode:"zzsxgm_2_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_10: {
						cellCode:"zzsxgm_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				{
					title: "教育费附加",
					disabledzzsxgm_2_x_1:true,
					disabledzzsxgm_2_x_2:false,
					disabledzzsxgm_2_x_3:false,
					disabledzzsxgm_2_x_4:true,
					disabledzzsxgm_2_x_5:false,
					disabledzzsxgm_2_x_6:false,
					disabledzzsxgm_2_x_7:false,
					disabledzzsxgm_2_x_8:true,
					disabledzzsxgm_2_x_9:false,
					disabledzzsxgm_2_x_10:true,
					zzsxgm_2_x_1: {
						cellCode:"zzsxgm_2_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_2: {
						cellCode:"zzsxgm_2_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_3: {
						cellCode:"zzsxgm_2_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_4: {
						cellCode:"zzsxgm_2_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_5: {
						cellCode:"zzsxgm_2_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_6: {
						cellCode:"zzsxgm_2_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_7: {
						cellCode:"zzsxgm_2_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_8: {
						cellCode:"zzsxgm_2_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_9: {
						cellCode:"zzsxgm_2_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_10: {
						cellCode:"zzsxgm_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},{
					title: "地方教育附加",
					disabledzzsxgm_2_x_1:true,
					disabledzzsxgm_2_x_2:false,
					disabledzzsxgm_2_x_3:false,
					disabledzzsxgm_2_x_4:true,
					disabledzzsxgm_2_x_5:false,
					disabledzzsxgm_2_x_6:false,
					disabledzzsxgm_2_x_7:false,
					disabledzzsxgm_2_x_8:true,
					disabledzzsxgm_2_x_9:false,
					disabledzzsxgm_2_x_10:true,
					zzsxgm_2_x_1: {
						cellCode:"zzsxgm_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_2: {
						cellCode:"zzsxgm_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_3: {
						cellCode:"zzsxgm_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_4: {
						cellCode:"zzsxgm_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_5: {
						cellCode:"zzsxgm_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_6: {
						cellCode:"zzsxgm_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_7: {
						cellCode:"zzsxgm_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_8: {
						cellCode:"zzsxgm_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_9: {
						cellCode:"zzsxgm_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_10: {
						cellCode:"zzsxgm_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "合计",
					disabledzzsxgm_2_x_1:true,
					disabledzzsxgm_2_x_2:true,
					disabledzzsxgm_2_x_3:true,
					disabledzzsxgm_2_x_4:true,
					disabledzzsxgm_2_x_5:true,
					disabledzzsxgm_2_x_6:true,
					disabledzzsxgm_2_x_7:true,
					disabledzzsxgm_2_x_8:true,
					disabledzzsxgm_2_x_9:true,
					disabledzzsxgm_2_x_10:true,
					zzsxgm_2_x_1: {
						cellCode:"zzsxgm_2_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_2: {
						cellCode:"zzsxgm_2_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_3: {
						cellCode:"zzsxgm_2_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_4: {
						cellCode:"zzsxgm_2_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_5: {
						cellCode:"zzsxgm_2_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_6: {
						cellCode:"zzsxgm_2_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_7: {
						cellCode:"zzsxgm_2_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_8: {
						cellCode:"zzsxgm_2_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_9: {
						cellCode:"zzsxgm_2_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					zzsxgm_2_x_10: {
						cellCode:"zzsxgm_2_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					}
				}
			]
		
	}
	return obj
}
